import { useUserSession } from '@solinkcorp/authentication';
import PreferenceStore from 'stores/PreferenceStore';
import { type SelectedPlayListSource } from 'utils/types';
import useFluxStore from './useFluxStore';

/**
 * Returns the user's selected playlist source.  If the user is cloud-only,
 * this will always return "cloudonly".
 */
export function usePlayListSource(): SelectedPlayListSource {
  const selectedPlayListSource = useFluxStore(
    PreferenceStore,
    (store) => store.getSelectedPlayListSource() as SelectedPlayListSource,
  );

  const user = useUserSession();
  const userIsCloudOnly = user.jwtUser.app_metadata.cloudOnly;

  return userIsCloudOnly ? 'cloudonly' : selectedPlayListSource;
}
